import axios from "axios";
import i18n from "i18next";
import GtfsRealtimeBindings from "gtfs-realtime-bindings";

import {
  BUS_ID_LINE_NUMBER,
  DEVIATION_REPORT,
  DEVIATION_REPORT_MAP,
  DISPATCH_CURRENT_ZOOM,
  DISPATCH_MAP_VIEW,
  DISPATCH_VEHICLE_ID,
  FETCH_ACTIVE_ASSIGNMENTS_TO_BLOCKS,
  FETCH_DATA_ACTIVE_BUS,
  FETCH_LINE_SHAPE_STOPS,
  GET_ACTIVE_BLOCKS,
  GET_ALL_CALENDARS,
  GET_BLOCKS_IDS,
  GET_BUSES,
  GET_CREDENTIALS,
  GET_DOWNLOADABLE_TA_CONTENT,
  GET_LAST_24_HOURS_DATA,
  GET_ROUTES_DETAILS,
  GET_ROUTES_LIST,
  GET_SCHEDULE_DETAILS,
  GET_CURRENT_SERVICE_ID,
  HISTORICAL_POSITIONS,
  POSITION_TIME,
  RESET_DATA_ACTIVE_BUS,
  REVERSE_GEOCODING_DONE,
  SET_ACTIVE_BUS,
  SET_DIRECTION,
  SET_LOADING_TABLE,
  SET_RANDOM_COLORS,
  SET_ROUTE_MAP_RANGE,
  SET_ROUTE_STOPS_BOTH,
  SHOW_ROUTES_TABLE,
  SHOW_STOPS,
  TRIP_RAPORT_DATA,
  DISPATCH_CURRENT_SHIFTS,
  DISPATCH_MAP_SETTINGS,
  DISPATCH_PROGRESS_BAR_DATA,
  GET_VEHICLE_SIRI_DATA,
  DISPATCH_BLOCK_STATISTICS,
  GET_CURRENT_CALENDAR_BLOCKS_IDS,
  GET_TRIP_DATA,
  RESET_TRIP_DATA,
  GET_GTFS_RT_TRIP_UPDATES,
  GET_AGENCY_ALERTS,
  GET_BUSES_IDS,
  IS_MAP_READY,
  SET_BLACK_ROUTES,
  PROFILE_DATA,
  BUS_LOCATIONS_BY_DATE,
  RESET_BUS_LOCATIONS_BY_DATE,
  DISPATCH_SELECTED_ROUTES_STOPS,
  START_WITH_ACCORDION,
  FILTER_BUSES_BY_TIME_DEVIATION,
  DISPATCH_AVERAGE_SPEED_DATA,
  DISPATCH_AVERAGE_SPEED_POLYLINE,
  FILTER_BUSES_BY_HEADWAY_DEVIATION_CATEGORY,
  DISPATCH_EARLY_LATE_SETTINGS,
  FILTER_BUSES_BY_ROUTE_ID,
  DISPATCH_BLOCK_TRIP_DATA,
  DISPATCH_AVG_TRIP_DATA,
  DISPATCH_ROUTES_TRIPS_DATA,
  DISPATCH_TRIP_INFO_DATA,
} from "./actionTypes";
import {
  alertHeaders,
  alertsBaseUrl,
  apiKey,
  apiPrefix,
  apiPrefixTaSchedule,
  apiVersionTC,
  axiosHeaders,
  configAgencyName,
  credentialsData,
  getOccupancyData,
  useLongVehicleDetails,
} from "./../config";
import {
  addEmptyDirection,
  addStringStatusToDownloadableContent,
  checkSubcontractorPKS,
  filterArrayNullProperties,
  findClosestTimeToSelectedTime,
  getAcronym,
  getLineNumber,
  getScheduleRelationshipString,
  infoNotify,
  random_HSL_ColorGenerator,
  removeAllUnderscores,
  removeCoordinatesDuplicates,
  removeDuplicates,
  removePKSXXX,
  sortRoutes,
  translateString,
  sortNumericallyAndAlphabetically,
} from "../utils/helpers";
import { exportTypeDefault, routeTypes } from "../data/constants";
import { addOccupancyStatusData, getGTFS_RT_vehiclePositions } from "../utils/reduxHelpers";

// Todo: Remove subcontractors from window.config!
const subcontractorsPKS = window?.config?.subcontractorsPKS || ([] as string[]);
// console.log({ subcontractorsPKS });

export const getRoutesDetails =
  () =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    let numberOfTrips: number;
    let tripsIds: string[];
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    try {
      const tripsIdsUrl = `${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/tripIds`;
      const tripsIdsData = await axios.get(tripsIdsUrl);
      numberOfTrips = await tripsIdsData?.data?.ids?.length;
      tripsIds = await tripsIdsData?.data?.ids;
    } catch (error) {
      if ((error as CustomError).response) {
        console.error("error.response.status:", ((error as CustomError)?.response as { status: number })?.status);
      }
    }

    await axios
      .get(`${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/routesDetails`)
      .then(({ data }) => {
        // console.log("data:", data);
        const agencyName: string = data?.agency;
        const routesInfo = [] as RouteDetails[];
        for (let i = 0; i < data?.routes?.length; i++) {
          const routeDetails: RouteDetails = {
            id: data?.routes[i]?.id,
            shortName: data?.routes[i]?.shortName,
            longName: data?.routes[i]?.longName,
            color: data?.routes[i]?.color ? `#${data?.routes[i]?.color}` : "#000000",
            textColor: data?.routes[i]?.textColor ? `#${data?.routes[i]?.textColor}` : "#ffffff",
            routeType: data?.routes[i]?.type,
            routeStopsIds: [
              ...new Set(
                data?.routes[i]?.direction
                  ?.map((elem: { stop: { id: string }[] }) => elem?.stop?.map((intElem) => intElem?.id))
                  .flat(1)
              ),
            ] as string[],
            patternShapes: [
              ...new Set(
                data?.routes[i]?.shape
                  ?.filter((elem: { loc: { lat: number; lon: number }[] }) => elem?.loc?.length >= 3)
                  ?.map((elem: { patternType: string }) => elem?.patternType)
              ),
            ] as string[],
          };

          if (configAgencyName === ("MiamiBeach" as string)) {
            routeDetails.acronym = getAcronym(routeDetails?.shortName);
          }

          routesInfo.push(routeDetails);
        }

        //* Trip pattern data
        const allTripsArray = [] as TripPattern[];
        for (let i = 0; i < data?.routes?.length; i++) {
          for (let j = 0; j < data?.routes[i]?.shape?.length; j++) {
            const tripObj: TripPattern = {
              routeId: data?.routes[i]?.id as string,
              tripPattern: data?.routes[i]?.shape[j]?.tripPattern as string,
              length: Number(data?.routes[i]?.shape[j]?.length?.toFixed(0)),
              directionId: data?.routes[i]?.shape[j]?.directionId as string,
              patternType: data?.routes[i]?.shape[j]?.patternType as string,
            };
            allTripsArray.push(tripObj);
          }
        }

        //* Stops Ids
        const allStopsArray = [] as StopInfo[];
        for (let i = 0; i < data?.routes?.length; i++) {
          for (let j = 0; j < data?.routes[i]?.direction?.length; j++) {
            for (let k = 0; k < data?.routes[i]?.direction[j]?.stop?.length; k++) {
              const stopObj: StopInfo = {
                stopId: data?.routes[i]?.direction?.[j]?.stop[k]?.id as string,
                stopName: data?.routes[i]?.direction?.[j]?.stop[k]?.name as string,
                lat: data?.routes[i]?.direction?.[j]?.stop[k]?.lat as number,
                lon: data?.routes[i]?.direction?.[j]?.stop[k]?.lon as number,
              };
              allStopsArray.push(stopObj);
            }
          }
        }
        const allStopsArrayFiltered: StopInfo[] = removeDuplicates(allStopsArray, "stopId");
        // console.log("allStopsArrayFiltered:", allStopsArrayFiltered);

        const agencyRoutesInfo = {
          agencyName: agencyName,
          routesInfo: sortRoutes(configAgencyName, routesInfo),
          allTripsArray: allTripsArray,
          allStopsArrayFiltered: allStopsArrayFiltered,
          numberOfTrips,
          sortedTripsIds: sortNumericallyAndAlphabetically(tripsIds),
        };

        // console.log("agencyRoutesInfo:", agencyRoutesInfo);
        dispatch({ type: GET_ROUTES_DETAILS, payload: agencyRoutesInfo });
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          console.log("error?.response?.status:", error?.response?.status);
        }
        if (error.response) {
          // console.log("error.response.data:", error.response.data);
          console.error("error.response.status:", error.response.status);
          // console.log("error.response.headers:", error.response.status);
        }
        // console.log("error.config:", error.config);
        // console.log("error:", error);
        // throw error;
        // throw new Error("No Active Blocks");
      });
    // .finally(() => console.log("Job done!"));
  };

export const getBusesIds =
  () =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    const URL: string = `${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/vehicleConfigs`;

    await axios
      .get(URL)
      .then(({ data }) => {
        const { vehicleConfigs }: { vehicleConfigs: VehicleConfig[] } = data || {};
        // console.log("vehicleConfigs:", vehicleConfigs);
        const busesIds: string[] = [...new Set(vehicleConfigs?.map((vehicle: VehicleConfig) => vehicle?.id))]?.sort(
          (a: string, b: string) => a.localeCompare(b)
        );
        // console.log("busesIds:", busesIds);
        let busesConfigs: VehicleConfig[] = busesIds?.map((bus: string) => {
          return { id: bus, name: vehicleConfigs?.find((vehicle: VehicleConfig) => vehicle?.id === bus)?.name as string };
        });
        //* Remove pksxxx from buses names - PKS
        if (configAgencyName === ("PoznanPKS" as string)) {
          busesConfigs = busesConfigs?.map((elem: VehicleConfig) => {
            return {
              ...elem,
              name: elem?.name?.split("(")?.[0]?.trim() || elem?.name,
            };
          });
        }
        // console.log("busesConfigs:", busesConfigs);
        dispatch({ type: GET_BUSES_IDS, payload: { busesIds, busesConfigs } });
      })
      .catch((error) => {
        if (error.response) {
          console.error("error.response.status:", error.response.status);
        }
      });
  };

export const getBuses =
  () =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const shifts = (await getState()?.constantValues?.currentShifts) as ObjectI;
    const busesIds = (await getState()?.constantValues?.busesIds) as string[];
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;
    const allowableLateRedux: number = await getState()?.constantValues?.earlyLateObj?.allowableLateRedux; //* [min]
    const allowableEarlyRedux: number = await getState()?.constantValues?.earlyLateObj?.allowableEarlyRedux; //* [min]

    const delayToleration: number = allowableLateRedux * 60 * 1000; //* [ms]
    const tooFastToleration: number = allowableEarlyRedux * 60 * 1000; //* [ms]
    // console.log("delayToleration, tooFastToleration:", delayToleration, tooFastToleration);

    let vehiclesUrl = "" as string;
    if (useLongVehicleDetails) {
      //* vehiclesUrl long
      const idsStrings = busesIds?.map((id: string) => `v=${id}&`);
      // console.log("idsStrings:", idsStrings);
      const stringOfIDs = idsStrings?.join("")?.slice(0, -1);
      // console.log("stringOfIDs:", stringOfIDs);
      vehiclesUrl = `${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/vehiclesDetails?numPreds=3&onlyAssigned=false&${stringOfIDs}`;
      // console.log("vehiclesUrl-Long.length:", vehiclesUrl?.length);
    } else {
      //* vehiclesUrl short
      vehiclesUrl = `${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/vehiclesDetails?numPreds=3&onlyAssigned=false`;
      // console.log("vehiclesUrl-Short.length:", vehiclesUrl?.length);
    }

    if (vehiclesUrl) {
      await axios
        .get(vehiclesUrl)
        .then(async ({ data }) => {
          // console.log("data:", data);

          let busesToSet = await filterArrayNullProperties(data?.vehicles as BusInfo[]);
          // console.log("busesToSet?.length:", busesToSet?.length);

          // String translation
          for (let i = 0; i < busesToSet.length; i++) {
            if (busesToSet[i].schAdhStr) {
              busesToSet[i].schAdhStr = translateString(busesToSet[i].schAdhStr);
            }
          }

          //* Subcontractors PKS checking
          if (configAgencyName === ("PoznanPKS" as string)) {
            busesToSet = await checkSubcontractorPKS(busesToSet, "vehicleName");
          }

          //* If there ARE shifts
          if (shifts && Object.keys(shifts).length >= 1) {
            for (let i = 0; i < busesToSet.length; i++) {
              for (const key in shifts) {
                if (busesToSet[i].block === shifts[key as keyof typeof shifts]) {
                  busesToSet[i].addedShift = key;
                }
              }
            }
          }
          //* If there are NO shifts
          for (let i = 0; i < busesToSet.length; i++) {
            if (!busesToSet[i].addedShift) {
              busesToSet[i].addedShift = i18n.t("b/d") as string;
            }
          }

          //* Remove pksxxx from buses names - PKS
          if (configAgencyName === ("PoznanPKS" as string)) {
            busesToSet = await removePKSXXX(busesToSet, "vehicleName");
          }

          //* Add vehicleTypeName
          for (let i = 0; i < busesToSet.length; i++) {
            for (let j = 0; j < routeTypes.length; j++) {
              if (busesToSet[i].vehicleType === routeTypes[j].vehicleType) {
                busesToSet[i].vehicleTypeName = routeTypes[j].vehicleTypeName;
              }
            }
          }

          //^ BusesWithLayover start
          const busesByLayover = busesToSet?.filter((bus: BusInfo) => bus?.layover) as BusInfo[];
          // console.log("busesByLayover:", busesByLayover);
          const busesByBlock = busesToSet?.filter((bus: BusInfo) => bus?.block) as BusInfo[];
          // console.log("busesByBlock:", busesByBlock);
          const busesByRouteShortName = busesToSet?.filter((bus: BusInfo) => bus?.routeShortName) as BusInfo[];
          // console.log("busesByRouteShortName:", busesByRouteShortName);
          const busesBySchAdh = busesToSet?.filter((bus: BusInfo) => bus?.schAdh || bus?.schAdh === 0) as BusInfo[];
          // console.log("busesBySchAdh:", busesBySchAdh);

          const workingAllBuses: BusInfo[] = [
            ...busesByLayover,
            ...busesByBlock,
            ...busesByRouteShortName,
            ...busesBySchAdh,
          ];
          // console.log("workingAllBuses:", workingAllBuses);
          //^ Final working buses ids
          const filteredWorkingAllBuses = removeDuplicates(workingAllBuses, "id") as BusInfo[];
          // console.log("filteredWorkingAllBuses:", filteredWorkingAllBuses);
          const filteredWorkingAllBusesIds: string[] = filteredWorkingAllBuses?.map((bus: BusInfo) => bus?.id);
          // console.log("filteredWorkingAllBusesIds:", filteredWorkingAllBusesIds);

          let busesOnTime: BusInfo[] = filteredWorkingAllBuses.filter(
            (elem: BusInfo) => elem.schAdh >= delayToleration && elem.schAdh <= tooFastToleration
          );
          busesOnTime.forEach((bus: BusInfo) => (bus.addedStatus = "busOnTime"));
          busesOnTime = addEmptyDirection(busesOnTime);
          // console.log("busesOnTime:", busesOnTime);

          let busesTooFast: BusInfo[] = filteredWorkingAllBuses.filter((elem: BusInfo) => elem.schAdh > tooFastToleration);
          busesTooFast.forEach((bus: BusInfo) => (bus.addedStatus = "busTooFast"));
          busesTooFast = addEmptyDirection(busesTooFast);
          // console.log("busesTooFast:", busesTooFast);

          let delayedBuses: BusInfo[] = filteredWorkingAllBuses.filter((elem: BusInfo) => elem.schAdh < delayToleration);
          delayedBuses.forEach((bus: BusInfo) => (bus.addedStatus = "delayedBus"));
          delayedBuses = addEmptyDirection(delayedBuses);
          // console.log("delayedBuses:", delayedBuses);

          // const remainingBuses: BusInfo[] = busesToSet.filter((elem: BusInfo) => !("schAdh" in elem)); //* V1
          const remainingBuses: BusInfo[] = busesToSet?.filter(
            (bus: BusInfo) => !filteredWorkingAllBusesIds?.includes(bus?.id)
          ); //* V2 -> rest of the buses
          remainingBuses.forEach((bus: BusInfo) => (bus.addedStatus = "remainingBus"));
          // console.log("remainingBuses:", remainingBuses);

          const busesIdsWithTimeStatus: string[] = filteredWorkingAllBuses
            ?.filter((bus: BusInfo) => bus?.schAdh || bus?.schAdh === 0)
            ?.map((filteredBs: BusInfo) => filteredBs?.id);
          // console.log("busesIdsWithTimeStatus:", busesIdsWithTimeStatus);

          //* Buses with layover -> rest of working buses
          const busesWithLayoverIds: string[] = filteredWorkingAllBusesIds?.filter(
            (busId: string) => !busesIdsWithTimeStatus?.includes(busId)
          );
          // console.log("busesWithLayoverIds:", busesWithLayoverIds);
          let busesWithLayover: BusInfo[] = filteredWorkingAllBuses?.filter((bus: BusInfo) =>
            busesWithLayoverIds?.includes(bus?.id)
          );
          busesWithLayover.forEach((bus: BusInfo) => (bus.addedStatus = "layoverBus"));
          busesWithLayover = addEmptyDirection(busesWithLayover);
          // console.log("busesWithLayover:", busesWithLayover);

          //* Occupancy Status Data
          if (getOccupancyData) {
            const occupancyStatusData = await getGTFS_RT_vehiclePositions(agencyId).then(
              (data: VehiclePositionsData[] | null) =>
                data?.filter((bus: VehiclePositionsData) => bus?.routeId || bus?.tripId) as VehiclePositionsData[]
            );
            // console.log("occupancyStatusData:", occupancyStatusData);

            busesOnTime = addOccupancyStatusData(busesOnTime, occupancyStatusData);
            busesTooFast = addOccupancyStatusData(busesTooFast, occupancyStatusData);
            delayedBuses = addOccupancyStatusData(delayedBuses, occupancyStatusData);
            busesWithLayover = addOccupancyStatusData(busesWithLayover, occupancyStatusData);
          }

          const busesToPass = {
            busesOnTime,
            busesTooFast,
            delayedBuses,
            remainingBuses,
            busesWithLayover,
            busesNumber: data?.vehicles?.length,
            workingBuses: busesOnTime?.length + busesTooFast?.length + delayedBuses?.length + busesWithLayover?.length,
          };
          dispatch({ type: GET_BUSES, payload: busesToPass });
        })
        .catch((error) => {
          if (error.response) {
            console.error("error.response.status:", error.response.status);
          }
          console.error("error.config:", error.config);
        });
    }
  };

export const getActiveBlocks =
  () =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    await axios
      .get(`${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/activeBlockByRouteNameWithVehicles?t=0`)
      .then(({ data }) => {
        // console.log(" data:", data);

        //* Subcontractors PKS checking
        if (configAgencyName === ("PoznanPKS" as string)) {
          const trimmedSubcontractorsPKS = subcontractorsPKS.map((elem) => elem.trim());
          // console.log("trimmedSubcontractorsPKS:", trimmedSubcontractorsPKS);
          for (let i = 0; i < data.routes.length; i++) {
            for (let j = 0; j < data.routes[i].block.length; j++) {
              if (data.routes[i]?.block[j]?.vehicle?.length) {
                for (let k = 0; k < data.routes[i].block[j].vehicle.length; k++) {
                  if (trimmedSubcontractorsPKS.includes(data.routes[i].block[j].vehicle[k].vehicleName)) {
                    data.routes[i].block[j].vehicle[k].subcontractorPKS = true;
                  }
                  if (!trimmedSubcontractorsPKS.includes(data.routes[i].block[j].vehicle[k].vehicleName)) {
                    data.routes[i].block[j].vehicle[k].subcontractorPKS = false;
                  }
                }
              }
            }
          }
        }

        //* Remove pksxxx from buses names - PKS
        if (configAgencyName === ("PoznanPKS" as string)) {
          for (let i = 0; i < data.routes.length; i++) {
            for (let j = 0; j < data.routes[i].block.length; j++) {
              if (data.routes[i]?.block[j]?.vehicle?.length) {
                for (let k = 0; k < data.routes[i].block[j].vehicle.length; k++) {
                  data.routes[i].block[j].vehicle[k].vehicleName =
                    data.routes[i].block[j].vehicle[k].vehicleName.split("(pks")[0];
                }
              }
            }
          }
        }
        dispatch({ type: GET_ACTIVE_BLOCKS, payload: data });
      })
      .catch((error) => {
        if (error.response) {
          console.error("error.response.status:", error.response.status);
        }
      });
  };

export const getVehicleSiriData =
  (urlParams: URLSearchParams) =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    await axios
      .get(`${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/siri/vehicleMonitoring?${urlParams}`)
      .then(({ data }) => {
        // console.log(" data:", data);
        const vehicleSiriData: VehicleSiriData[] = data?.ServiceDelivery["VehicleMonitoringDelivery "]?.VehicleActivity?.map(
          (vehicle: { MonitoredVehicleJourney: { VehicleRef: string; Monitored: string; LineRef: string } }) => {
            return {
              id: vehicle?.MonitoredVehicleJourney?.VehicleRef,
              monitored: Boolean(vehicle?.MonitoredVehicleJourney?.Monitored),
              route: vehicle?.MonitoredVehicleJourney?.LineRef,
            };
          }
        );
        // console.log("vehicleSiriData:", vehicleSiriData);
        dispatch({ type: GET_VEHICLE_SIRI_DATA, payload: { vehicleSiriData } });
      })
      .catch((error) => {
        if (error.response) {
          console.error("error.response.status:", error.response.status);
        }
      });
  };

export const getBlocksIds =
  () =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    const URL = `${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/blockIds`;
    await axios
      .get(URL)
      .then((response) => {
        const blocksIds = response?.data?.ids;
        // console.log({ blocksIds });
        const uniqueBlocksIds = [...new Set(blocksIds)] as string[];
        const sortedBlocksIds = uniqueBlocksIds.sort();
        dispatch({ type: GET_BLOCKS_IDS, payload: { sortedBlocksIds } });
      })
      .catch((error) => {
        if (error.response) {
          console.error("error.response.status:", error.response.status);
        }
        console.error("error.config:", error.config);
      });
  };

export const setActiveBus = (busId: string) => async (dispatch: Dispatch) => {
  try {
    // console.log({ busId });
    dispatch({ type: SET_ACTIVE_BUS, payload: { busId } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const fetchDataActiveBus =
  (routeId: string, direction: string) =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    await axios
      .get(`${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/routesDetails?r=${routeId}`)
      .then(({ data }) => {
        // console.log("data:", data);
        const lineStops = data?.routes[0]?.direction;
        const lineShape = data?.routes[0]?.shape;
        const selectedDirection = direction;
        const tableRouteData = {
          lineStops,
          lineShape,
          selectedDirection,
          routeId,
        };
        dispatch({ type: FETCH_DATA_ACTIVE_BUS, payload: { tableRouteData } });
      })
      .catch((error) => {
        console.log("error:", error);
      });
  };

export const resetDataActiveBus = () => async (dispatch: Dispatch) => {
  // console.log("resetDataActiveBus");

  try {
    const tableRouteData = {
      lineStops: [],
      lineShape: [],
      selectedDirection: "notSet",
    };
    dispatch({ type: RESET_DATA_ACTIVE_BUS, payload: { tableRouteData } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const fetchLinesShapeStops =
  (line: string) =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    await axios
      .get(`${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/routesDetails?r=${line}`)
      .then(({ data }) => {
        // console.log("data:", data);
        const lineStops = data?.routes[0]?.direction;
        const lineShape = data?.routes[0]?.shape;
        const selectedLine = data?.routes[0]?.id;
        const onlyOneLine = true;

        dispatch({ type: FETCH_LINE_SHAPE_STOPS, payload: { selectedLine, lineStops, lineShape, onlyOneLine } });
      })
      .catch((error) => {
        console.log("error:", error);
      });
  };

export const resetLinesShapeStops = () => async (dispatch: Dispatch) => {
  try {
    const lineStops = [] as Array<BusStopDirection>;
    const lineShape = [] as Array<Location>;
    const selectedLine = "";
    const onlyOneLine = false;
    dispatch({ type: FETCH_LINE_SHAPE_STOPS, payload: { selectedLine, lineStops, lineShape, onlyOneLine } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const setDirection = (direction: string) => async (dispatch: Dispatch) => {
  // console.log({ direction });
  try {
    dispatch({ type: SET_DIRECTION, payload: { direction } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const showStops = (showBusStops: boolean) => async (dispatch: Dispatch) => {
  // console.log({ showBusStops });
  try {
    dispatch({ type: SHOW_STOPS, payload: { showBusStops } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const dispatchCoordinates =
  (lat: number | null, lon: number | null, zoom: number | null) => async (dispatch: Dispatch) => {
    const mapView = { lat: lat, lon: lon, zoom: zoom } as MapView;
    try {
      dispatch({ type: DISPATCH_MAP_VIEW, payload: { mapView } });
    } catch (error) {
      console.log("error:", error);
    }
  };

export const setHistoricalPositions = (historicalPositions: VehicleReportAVL[]) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: HISTORICAL_POSITIONS, payload: { historicalPositions } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const setRouteStopsBoth = (routeStopsBoth: string) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: SET_ROUTE_STOPS_BOTH, payload: { routeStopsBoth } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const setBusId_LineNumber = (busId: string, lineNumber: string) => async (dispatch: Dispatch) => {
  const busId_LineNumber = { busId: busId, lineNumber: lineNumber };
  // console.log({ busId, lineNumber });
  try {
    dispatch({ type: BUS_ID_LINE_NUMBER, payload: { busId_LineNumber } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const setPositionTime = (positionTime: string) => async (dispatch: Dispatch) => {
  // console.log("positionTime:", positionTime);
  try {
    dispatch({ type: POSITION_TIME, payload: { positionTime: positionTime } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const getRoutesList =
  () =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    await axios
      .get(`${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/routes?keepDuplicates=false`)
      .then(({ data }) => {
        // console.log("data:", data);
        const dataToProceed = data?.routes;
        // console.log("dataToProceed:", dataToProceed);
        const listRoutesNamesLong = [] as string[];
        dataToProceed.forEach((routes: { name: string; shortName: string; longName: string }) => {
          if (routes.name.includes(" - ")) {
            listRoutesNamesLong.push(routes.name);
          } else {
            listRoutesNamesLong.push(`${routes.shortName} - ${routes.longName}`);
          }
        });

        // console.log("listRoutesNamesLong", listRoutesNamesLong);
        const listRoutesNames = listRoutesNamesLong.map((item: string) => getLineNumber(item));
        // console.log("listRoutesNames:", listRoutesNames);
        dispatch({ type: GET_ROUTES_LIST, payload: { listRoutesNames } });

        //* Route with trips
        if (
          dataToProceed
            ?.map((elem: { tripIds: string[] }) => elem?.tripIds)
            ?.filter((mappedElem: string[]) => mappedElem !== undefined)?.length
        ) {
          const routesWithTrips = dataToProceed?.map((elem: { id: string; shortName: string; tripIds: string[] }) => {
            return {
              routeId: elem?.id,
              routeShortName: elem?.shortName,
              trips: elem?.tripIds,
            };
          }) as RoutesTripsData[];
          // console.log("routesWithTrips:", routesWithTrips);
          dispatch({ type: DISPATCH_ROUTES_TRIPS_DATA, payload: { routesWithTrips } });
        }
      })
      .catch((error) => {
        if (error.response) {
          console.error("error.response.status:", error.response.status);
        }
        console.error("error.config:", error.config);
      });
  };

export const setLoadingTable = (value: boolean) => async (dispatch: Dispatch) => {
  try {
    // console.log({ value});
    dispatch({ type: SET_LOADING_TABLE, payload: { loadingTable: value } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const showRoutesTable = (showRoutes_Table: boolean) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: SHOW_ROUTES_TABLE, payload: { showRoutes_Table } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const fetchActiveAssignmentsToBlocks =
  () =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    //* To check all assignments: dispatch vehicleAssignments and change in TableBigComponent.tsx to vehicleAssignments!
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;
    const onlyValidAssignments = true;

    await axios
      .get(`${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/vehiclesToBlock?actual=${onlyValidAssignments}`)
      .then(({ data }) => {
        // console.log("data:", data);

        const vehicleAssignments: VehicleToBlock[] = data?.vehicleToBlock;
        // console.log("vehicleAssignments:", vehicleAssignments);
        //* Filter only valid assignments!
        const timeNow = new Date();
        const vehicleValidAssignments = vehicleAssignments.filter((elem) => new Date(elem?.validTo) > timeNow);
        // console.log("vehicleValidAssignments:", vehicleValidAssignments);
        dispatch({ type: FETCH_ACTIVE_ASSIGNMENTS_TO_BLOCKS, payload: { vehicleValidAssignments } });
      })
      .catch((error) => {
        if (error.response) {
          console.error("error.response.status:", error.response.status);
        }
        console.error("error.config:", error.config);
      });
  };

export const setDeviationReportData =
  (deviationReportData: Array<DeviationReport>, startDate: Date) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: DEVIATION_REPORT, payload: { deviationReportData: deviationReportData, startDate: startDate } });
    } catch (error) {
      console.log("error:", error);
    }
  };

export const setDeviationReportMapData = (deviationMapData: DeviationReport) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: DEVIATION_REPORT_MAP, payload: { deviationMapData } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const setRouteMapRange =
  (
    rangeMapArray: {
      lat: number;
      lng: number;
    }[]
  ) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({ type: SET_ROUTE_MAP_RANGE, payload: { rangeMapArray } });
    } catch (error) {
      console.log("error:", error);
    }
  };

export const getTripsReportData =
  (
    tripReport: TripReport[],
    selectedDay: Date,
    tripToFetch: { value: string; label: string } | null,
    vehicleId: string[],
    tripInfo: TripInfo
  ) =>
  async (dispatch: Dispatch) => {
    // console.log("tripReport:", tripReport);
    const tripReportData = { tripReport, selectedDay, tripToFetch, vehicleId, tripInfo };
    try {
      dispatch({ type: TRIP_RAPORT_DATA, payload: tripReportData });
    } catch (error) {
      console.log("error:", error);
    }
  };

export const setReverseGeocodingDone = (geocodingDataLoading: boolean) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: REVERSE_GEOCODING_DONE, payload: { geocodingDataLoading } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const getLast24hPositions =
  () =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    await axios
      .get(`${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/reports/lastAvlJsonData`)
      .then(({ data }) => {
        // console.log("data:", data);
        let dataToSet = data.data;
        dataToSet = dataToSet.sort((a: Last24HoursPositions, b: Last24HoursPositions) =>
          a.vehicleId.localeCompare(b.vehicleId)
        );
        // console.log("dataToSet:", dataToSet);

        //* Remove pksxxx from buses names - PKS
        if (configAgencyName === ("PoznanPKS" as string)) {
          dataToSet = removePKSXXX(dataToSet, "name");
        }

        dispatch({ type: GET_LAST_24_HOURS_DATA, payload: { positions: dataToSet } });
      })
      .catch((error) => {
        if (error.response) {
          console.error("error.response.status:", error.response.status);
        }
        console.error("error.config:", error.config);
      });
  };

export const dispatchRandomColors = (colorsArray: string[]) => async (dispatch: Dispatch) => {
  // console.log("colorsArray:", colorsArray);
  try {
    dispatch({ type: SET_RANDOM_COLORS, payload: { colorsArray } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const dispatchVehicleId = (vehicleId: string) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: DISPATCH_VEHICLE_ID, payload: { vehicleId } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const dispatchCurrentZoom = (currentZoom: number) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: DISPATCH_CURRENT_ZOOM, payload: { currentZoom } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const getCurrentServiceId =
  () =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    await axios
      .get(`${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/currentCalendars`)
      .then(({ data }) => {
        // console.log("data:", data);
        const currentCalendar = data?.calendars;
        dispatch({ type: GET_CURRENT_SERVICE_ID, payload: { currentCalendar } });
      })
      .catch((error) => {
        if (error.response) {
          console.error("error.response.status:", error.response.status);
        }
        console.error("error.config:", error.config);
      });
  };

export const getCurrentCalendarBlockIds =
  (currentCalendarsIds: string[]) =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    if (currentCalendarsIds && currentCalendarsIds?.length) {
      const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

      //* For if TC3.0 endpoint: /command/serviceIdsWithBlocks else endpoint: /command/serviceIds?withBlockIds=true
      const servicesBlocksUrl =
        apiVersionTC === ("TC3.0" as string)
          ? `${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/serviceIdsWithBlocks`
          : `${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/serviceIds?withBlockIds=true`;
      // console.log("servicesBlocksUrl:", servicesBlocksUrl);

      await axios
        .get(servicesBlocksUrl)
        .then(({ data }) => {
          // console.log("data:", data);
          const servicesBlocks = data?.serviceIds;
          // console.log("servicesBlocks:", servicesBlocks);
          if (servicesBlocks) {
            //* TC_API_V2 - one request
            // console.log("servicesBlocks:", servicesBlocks);
            const currentServicesBlocks = servicesBlocks?.filter((elem: { id: string }) =>
              currentCalendarsIds?.includes(elem?.id)
            );
            // console.log("currentServicesBlocks:", currentServicesBlocks);
            const blocksIds = currentServicesBlocks?.map((elem: { blockIds: string[] }) => elem?.blockIds)?.flat(1);
            // console.log("blocksIds:", blocksIds);
            const blocksIdsUnique = [...new Set(blocksIds)];
            // console.log("blocksIdsUnique:", blocksIdsUnique);
            dispatch({
              type: GET_CURRENT_CALENDAR_BLOCKS_IDS,
              payload: { currentServiceBlocksIds: blocksIdsUnique },
            });
          } else {
            //* TC_API_V1 - many requests!
            const apiBase = `${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command`;
            const endpoints = currentCalendarsIds?.map(
              (serviceId: string) => `${apiBase}/blockIds?serviceId=${encodeURIComponent(serviceId)}`
            );
            // console.log("endpoints:", endpoints);

            axios
              .all(endpoints.map((endpoint: string) => axios.get(endpoint)))
              .then((data) => {
                // console.log("data:", data);
                const currentBlocksIds = [] as string[];
                for (let i = 0; i < data.length; i++) {
                  if (data[i]?.data?.ids?.length >= 1) {
                    currentBlocksIds.push(data[i]?.data?.ids);
                  }
                }
                // console.log("currentBlocksIds:", currentBlocksIds);
                const currentBlocksIdsFlat = [...new Set(currentBlocksIds?.flat(1))];
                // console.log("currentBlocksIdsFlat:", currentBlocksIdsFlat);
                dispatch({
                  type: GET_CURRENT_CALENDAR_BLOCKS_IDS,
                  payload: { currentServiceBlocksIds: currentBlocksIdsFlat },
                });
              })
              .catch((error) => {
                if (error.response) {
                  console.error("error.response.status:", error.response.status);
                }
                console.error("error.config:", error.config);
              });
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("error.response.status:", error.response.status);
          }
          console.error("error.config:", error.config);
        });
    }
  };

// Todo: refactor with getDownloadableStopsData
export const getDownloadableTA_content =
  (type: number) =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    try {
      const { data } = await axios.get(
        `${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/exports?type=${type ?? exportTypeDefault}`
      );
      // console.log("data:", data);
      const downloadableContentAVL = ((data?.exports || data?.exportsData) as DownloadableContent[])
        //* Filter data: return data now + one day - Dates are timestamps!
        ?.filter((elem: DownloadableContent) => elem?.dataDate <= Date.now() + 24 * 60 * 60 * 1000)
        //* Sort by dataDate ascending and then by exportDate ascending - Dates are timestamps!
        ?.sort(
          (a: DownloadableContent, b: DownloadableContent) => b?.dataDate - a?.dataDate || b?.exportDate - a?.exportDate
        );
      // console.log("downloadableContentAVL:", downloadableContentAVL);

      const downloadableContentModifiedAVL: DownloadableContent[] =
        addStringStatusToDownloadableContent(downloadableContentAVL);
      // console.log("downloadableContentModifiedAVL:", downloadableContentModifiedAVL);

      const downloadableContentFilteredAVL: DownloadableContent[] = removeDuplicates(
        downloadableContentModifiedAVL,
        "dataDate"
      );
      // console.log("downloadableContentFilteredAVL:", downloadableContentFilteredAVL);

      dispatch({ type: GET_DOWNLOADABLE_TA_CONTENT, payload: { downloadableTA_Content: downloadableContentFilteredAVL } });
    } catch (error) {
      if ((error as CustomError).response) {
        console.error("error.response.status:", ((error as CustomError).response as { status: number }).status);
      }
      console.error("error.config:", (error as CustomError).config);
    }
  };

//* New Actions
export const getCredentials = () => async (dispatch: Dispatch) => {
  const URL = `${apiPrefixTaSchedule}/oauth/token`;

  axios
    .post(URL, credentialsData, { headers: axiosHeaders })
    .then(({ data }) => {
      // console.log({ data });
      dispatch({ type: GET_CREDENTIALS, payload: { credentials: data } });
    })
    .catch((error) => {
      if (error.response) {
        console.error("error.response.status:", error.response.status);
      }
      if (error.message) {
        console.error("error.message:", error.message);
      }
    });
};

export const getScheduleDetails =
  (bearerToken: string, currentDate: string) =>
  async (dispatch: Dispatch): Promise<void> => {
    const URL = `${apiPrefixTaSchedule}/api/v1/scheduleDetails/byDate/${currentDate}`;
    const axiosConfig = {
      headers: {
        ...axiosHeaders,
        Authorization: `Bearer ${bearerToken}`,
        //* Check DB name if agency is FortLauderdale
        namedb:
          configAgencyName === ("SmallCities" as string) ||
          configAgencyName === ("FortLauderdale" as string) ||
          configAgencyName === ("PompanoBeach" as string) ||
          configAgencyName === ("BCT" as string)
            ? "TA_SCHEDULE_FORTLAUDERDALE"
            : "TA_SCHEDULE", //* Fort Lauderdale/PompanoBeach/BCT or other carriers!
      },
    };
    // console.log("axiosConfig?.headers:", axiosConfig?.headers);

    await axios
      .get(URL, axiosConfig)
      .then(({ data }) => {
        // console.log("data:", data);
        if (data?.status === "success") {
          const scheduleDetails = data?.data;
          // console.log("scheduleDetails:", scheduleDetails);
          const scheduleDetailsSorted = scheduleDetails?.sort((a: CompareApisData, b: CompareApisData) =>
            a?.vehicle?.localeCompare(b?.vehicle)
          );
          dispatch({ type: GET_SCHEDULE_DETAILS, payload: { scheduleDetailsSorted } });
        }
      })
      .catch((error) => {
        if (error.response) {
          console.error("error.response.status:", error.response.status);
        }
        if (error.message) {
          console.error("error.message:", error.message);
        }
      });
  };

export const getAllCalendars =
  () =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    await axios
      .get(`${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/allCalendars`)
      .then(({ data }) => {
        // console.log("data:", data);
        const allCalendars = data?.calendars;
        // console.log("allCalendars:", allCalendars);
        dispatch({ type: GET_ALL_CALENDARS, payload: { allCalendars } });
      })
      .catch((error) => {
        if (error.response) {
          console.error("error.response.status:", error.response.status);
        }
        console.error("error.config:", error.config);
      });
  };

export const dispatchCurrentShifts = (currentShifts: Object) => async (dispatch: Dispatch) => {
  // console.log({ currentShifts });
  if (currentShifts && Object.keys(currentShifts).length) {
    try {
      dispatch({ type: DISPATCH_CURRENT_SHIFTS, payload: { currentShifts } });
    } catch (error) {
      console.log("error:", error);
    }
  }
};

export const dispatchMapSettings = (mapSettings: MapSettings) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: DISPATCH_MAP_SETTINGS, payload: { mapSettings } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const dispatchProgressBarData = (progressBarData: ProgressBarData) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: DISPATCH_PROGRESS_BAR_DATA, payload: { progressBarData } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const dispatchBlockStatistics =
  (fetchDate: Date) =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;
    const { busesOnTime, busesTooFast, delayedBuses, remainingBuses, busesWithLayover } = await getState()?.buses;
    const busesStatistics = {
      busesOnTimeLength: busesOnTime?.length,
      busesTooFastLength: busesTooFast?.length,
      delayedBusesLength: delayedBuses?.length,
      remainingBusesLength: remainingBuses?.length,
      busesWithLayoverLength: busesWithLayover?.length,
    };
    // console.log("busesStatistics:", busesStatistics);

    if (agencyId && busesStatistics && Object?.keys(busesStatistics)?.length) {
      await axios
        .get(`${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/activeBlocksByRouteWithoutVehicles`)
        .then(({ data }) => {
          // console.log("data:", data);
          const blocksNumber = data?.routes
            ?.map((route: { block: Block[] }) => route?.block?.length)
            ?.reduce((a: number, b: number) => a + b, 0);
          // console.log("blocksNumber:", blocksNumber);
          const busesStats = { fetchDate, blocksNumber, busesStatistics };
          dispatch({ type: DISPATCH_BLOCK_STATISTICS, payload: { busesStats } });
        })
        .catch((error) => {
          if (error.response) {
            console.error("error.response.status:", error.response.status);
          }
        });
    }
  };

//* New Actions_2
export const getTripData =
  (currentBusId: string, currentTripId: string, currentRouteId: string) =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const routesInfo = await getState()?.routesInfo?.routesInfo;
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    if (routesInfo && routesInfo.length) {
      const currentRouteInfo = routesInfo.filter((elem: RouteDetails) => elem.id === currentRouteId)?.[0];
      // console.log("currentRouteInfo:", currentRouteInfo);

      //* Nested axios requests
      await axios
        .get(`${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/stops?r=${encodeURIComponent(currentRouteId)}`)
        .then(({ data }) => {
          // console.log("data:", data);
          const stopsArray = [] as BusStop[];
          for (let i = 0; i < data?.direction.length; i++) {
            for (let j = 0; j < data?.direction[i].stop.length; j++) {
              stopsArray.push(data?.direction[i]?.stop[j]);
            }
          }
          const stopsArrayFiltered: BusStop[] = removeDuplicates(stopsArray, "id");
          // console.log("stopsArrayFiltered:", stopsArrayFiltered);
          return stopsArrayFiltered;
        })
        .then((stopsArrayFiltered: BusStop[]) => {
          return axios
            .get(`${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/trip?tripId=${encodeURIComponent(currentTripId)}`)
            .then(({ data }) => {
              // console.log("data:", data);
              const currentTripData: CurrentTripData = {
                lengthsArray: data?.tripPattern?.stopPaths?.map((stop: { pathLength: number }) => stop?.pathLength),
                routeInfo: currentRouteInfo,
                tripId: data?.id,
                shortName: data?.shortName,
                startTime: data?.startTime,
                endTime: data?.endTime,
                directionId: data?.directionId,
                routeId: data?.routeId,
                routeShortName: data?.routeShortName,
                serviceId: data?.serviceId,
                headsign: data?.headsign,
                blockId: data?.blockId,
                shapeId: data?.shapeId,
                extent: data?.tripPattern?.extent,
                tripPattern: data?.tripPattern?.id,
                //* Remove duplicates of coordinates
                stopPaths: removeCoordinatesDuplicates(
                  data?.tripPattern?.stopPaths.map((stop: { locations: LanLngPoint[] }) => stop?.locations).flat(1),
                  true
                ),
                pathLength: data?.tripPattern?.stopPaths
                  ?.map((stop: { pathLength: number }) => stop?.pathLength)
                  ?.reduce((accumulator: number, currentValue: number) => accumulator + currentValue, 0),
                schedule: data?.schedule?.map((elem: { stopId: string }) => {
                  return {
                    ...elem,
                    gtfsStopSeq: data?.tripPattern?.stopPaths?.find(
                      (stopSeq: { stopId: string }) => stopSeq?.stopId === elem?.stopId
                    )?.gtfsStopSeq as number,
                    position: {
                      lat: stopsArrayFiltered?.filter((stop: BusStop) => stop.id === elem.stopId)?.[0]?.lat,
                      lon: stopsArrayFiltered?.filter((stop: BusStop) => stop.id === elem.stopId)?.[0]?.lon,
                    },
                  };
                }),
              };
              // console.log("currentTripData:", currentTripData);
              dispatch({ type: GET_TRIP_DATA, payload: { currentTripData: currentTripData, currentBusId } });
            })
            .catch((error) => {
              if (error.response) {
                console.error("error.response.status:", error.response.status);
              }
            });
        })
        .catch((error) => {
          if (error.response) {
            infoNotify("warning", i18n.t("Brak danych"));
            console.error("error.response.status:", error.response.status);
          }
        });
    }
  };

export const resetTripData = () => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: RESET_TRIP_DATA, payload: { currentTripData: {}, currentBusId: "" } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const dispatchIsMapReady = (isMapReady: boolean) => async (dispatch: Dispatch) => {
  // console.log("isMapReady:", isMapReady);
  try {
    dispatch({ type: IS_MAP_READY, payload: { isMapReady } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const dispatchBlackRoutes = (blackRoutes: boolean) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: SET_BLACK_ROUTES, payload: { blackRoutes } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const getGTFS_RT_tripUpdates =
  () =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    try {
      const url = `${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/command/gtfs-rt/tripUpdates`;
      const scheduleRelationshipTripsArray = [] as CancelReenableTrip[];
      const response = await axios.get(url, { headers: {}, responseType: "arraybuffer" });
      if (response.status !== 200) {
        const error = new Error(`${response.config.url}: ${response.status} ${response.statusText}`);
        console.log("error:", error);
      }

      const buffer: Uint8Array = new Uint8Array(response.data);
      const feed = GtfsRealtimeBindings.transit_realtime.FeedMessage.decode(
        buffer
      ) as GtfsRealtimeBindings.transit_realtime.FeedMessage;
      // console.log("feed?.entity:", feed?.entity);

      feed?.entity.forEach((dataGTFS: GtfsRealtimeBindings.transit_realtime.IFeedEntity) => {
        const objectDataGTFS = {
          tripId: dataGTFS?.id as string,
          startDate: dataGTFS?.tripUpdate?.trip?.startDate as string,
          scheduleRelationship: getScheduleRelationshipString(
            dataGTFS?.tripUpdate?.trip?.scheduleRelationship as number
          ) as string, //* Always exists - trip updates - no need to check hasOwnProperty!
          routeId: dataGTFS?.tripUpdate?.trip?.routeId as string,
          vehicleId: dataGTFS?.tripUpdate?.vehicle?.id as string,
          timestamp: dataGTFS?.tripUpdate?.timestamp as number,
          stopTimeUpdate: dataGTFS?.tripUpdate
            ?.stopTimeUpdate as GtfsRealtimeBindings.transit_realtime.TripUpdate.IStopTimeUpdate[],
        };
        scheduleRelationshipTripsArray.push(objectDataGTFS);
      });
      // console.log("scheduleRelationshipTripsArray:", scheduleRelationshipTripsArray);

      dispatch({ type: GET_GTFS_RT_TRIP_UPDATES, payload: { scheduleRelationshipTripsArray } });
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.log("error?.response?.status:", error?.response?.status);
      }
      if (error instanceof Error) {
        console.log("error?.message:", error?.message);
        console.log("error?.status:", error?.name);
      }
    }
  };

//* Snapshot report only
export const getBusLocationsByDate =
  (selectedTime: string, fetchDateFormatted: string, numDays: number, beginTime: string, endTime: string) =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    const routesInfo: RouteDetails[] = await getState()?.routesInfo?.routesInfo;
    // console.log("routesInfo:", routesInfo);

    const url = `${apiPrefix}/v1/key/${apiKey}/agency/${agencyId}/reports/avlReport?beginDate=${fetchDateFormatted}&numDays=${numDays}&beginTime=${beginTime}&endTime=${endTime}&screenShot=true`;

    await axios
      .get(url)
      .then(async ({ data: { data } }: { data: { data: VehicleReportAVL[] } }) => {
        // console.log(1, "data:", data);
        data = removeAllUnderscores(data as VehicleReportAVL[]) as VehicleReportAVL[];
        // console.log(2, "data:", data);

        const vehiclesArray = [...new Set(data.map((vehicleObj) => vehicleObj?.vehicleid))];
        // console.log("vehiclesArray:", vehiclesArray);

        //* Possible to do it in a shorter way!
        let busLocationsByDate = (await vehiclesArray
          ?.map((vehicle: string) => {
            return {
              vehicleId: vehicle,
              position: findClosestTimeToSelectedTime(
                data?.filter((vehicleObj: VehicleReportAVL) => vehicleObj?.vehicleid === vehicle),
                selectedTime
              ),
            };
          })
          ?.map((vehicle) => vehicle?.position)) as VehicleReportAVL[];

        //* Subcontractors PKS checking
        if (configAgencyName === ("PoznanPKS" as string)) {
          busLocationsByDate = await checkSubcontractorPKS(busLocationsByDate, "name");
        }

        //* Remove pksxxx from buses names - PKS
        if (configAgencyName === ("PoznanPKS" as string)) {
          busLocationsByDate = await removePKSXXX(busLocationsByDate, "name");
        }

        const generatedColors = await random_HSL_ColorGenerator(busLocationsByDate?.length);
        // console.log("generatedColors:", generatedColors);
        busLocationsByDate = busLocationsByDate.map((busLocation: VehicleReportAVL, index: number) => {
          return {
            ...busLocation,
            randomColor: generatedColors[index],
            routeName: routesInfo?.find((route) => route?.id === busLocation?.route)?.shortName,
          };
        });
        // console.log("busLocationsByDate:", busLocationsByDate);

        dispatch({ type: BUS_LOCATIONS_BY_DATE, payload: { busLocationsByDate } });
      })
      .catch((error) => {
        if (error.response) {
          console.error("error.response.status:", error.response.status);
        }
      });
  };

export const resetBusLocationsByDate = () => async (dispatch: Dispatch) => {
  // console.log("resetBusLocationsByDate");
  try {
    dispatch({ type: RESET_BUS_LOCATIONS_BY_DATE, payload: { busLocationsByDate: null } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const dispatchSelectedRoutesStops =
  (selectedRoutes: string[], selectedRoutesForStops: string[]) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: DISPATCH_SELECTED_ROUTES_STOPS, payload: { selectedRoutes, selectedRoutesForStops } });
    } catch (error) {
      console.log("error:", error);
    }
  };

//* Alerts
export const getAgencyAlerts =
  (showInfo: boolean = true) =>
  async (dispatch: Dispatch, getState: Fetch): Promise<void> => {
    const agencyId: string = await getState()?.constantValues?.agencyIdFromContext;

    await axios
      .get(`${alertsBaseUrl}/agency/${agencyId}/alerts`, { headers: alertHeaders })
      .then(({ data, status }) => {
        const alertsData: Alert[] = data && data.length > 0 ? filterArrayNullProperties(data) : [];
        // console.log({ status }, "alertsData:", alertsData);
        dispatch({
          type: GET_AGENCY_ALERTS,
          payload: {
            status: status,
            alerts: alertsData,
          },
        });

        if (status === 200 && alertsData.length && showInfo) {
          infoNotify("info", i18n.t("Alerts have been downloaded"));
        }
        if (status === 204 || (!alertsData.length && showInfo)) {
          infoNotify("success", i18n.t("No alerts"));
        }
      })
      .catch((error) => {
        if (error.response) {
          console.error("error.response.status:", error.response.status);
        }
      });
  };

//* Chart Profile
export const dispatchProfileData =
  (profileData: [{ latitude: number; longitude: number }[], PointElevation[]]) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: PROFILE_DATA, payload: { profileData } });
    } catch (error) {
      console.log("error:", error);
    }
  };

//* Swiftly
export const filterBusesByTimeDeviation = (kindOfTimeDeviation: string) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: FILTER_BUSES_BY_TIME_DEVIATION, payload: { kindOfTimeDeviation } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const filterBusesByRouteId = (filterByRouteId: string) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: FILTER_BUSES_BY_ROUTE_ID, payload: { filterByRouteId } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const dispatchAverageSpeedData = (averageSpeedData: AverageSpeedData[] | null) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: DISPATCH_AVERAGE_SPEED_DATA, payload: { averageSpeedData } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const dispatchAverageSpeedPolyline =
  (
    encodedPolyline: string | null,
    tripPattern: string | null,
    stopsOrderData: string[] | null,
    averageSpeedsRouteId: string | null,
    averageSpeedsDirectionId: string | null
  ) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({
        type: DISPATCH_AVERAGE_SPEED_POLYLINE,
        payload: { encodedPolyline, tripPattern, stopsOrderData, averageSpeedsRouteId, averageSpeedsDirectionId },
      });
    } catch (error) {
      console.log("error:", error);
    }
  };

export const dispatchHeadwayDeviationCategory = (headwayDeviationCategory: string) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: FILTER_BUSES_BY_HEADWAY_DEVIATION_CATEGORY, payload: { headwayDeviationCategory } });
  } catch (error) {
    console.log("error:", error);
  }
};

//* New Actions_3
export const dispatchStartWithAccordion = (startWithAccordion: boolean) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: START_WITH_ACCORDION, payload: { startWithAccordion } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const dispatchEarlyLateSettings =
  (earlyLateObj: { allowableLateRedux: number; allowableEarlyRedux: number }) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: DISPATCH_EARLY_LATE_SETTINGS, payload: { earlyLateObj } });
    } catch (error) {
      console.log("error:", error);
    }
  };

export const dispatchBlockTripData = (blockTripData: BlockTripData | null) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: DISPATCH_BLOCK_TRIP_DATA, payload: { blockTripData } });
  } catch (error) {
    console.log("error:", error);
  }
};

export const dispatchAverageTripData =
  (
    averageTripData: {
      pathPoints: [number, number][];
      bounds: [number, number][];
      tripData: { [key: string]: string };
      averageData: AveragePaxCountTripData[];
    } | null
  ) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({ type: DISPATCH_AVG_TRIP_DATA, payload: { averageTripData } });
    } catch (error) {
      console.log("error:", error);
    }
  };

export const dispatchTripInfoData = (tripInfoData: TripInfoReport | null) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: DISPATCH_TRIP_INFO_DATA, payload: { tripInfoData: tripInfoData } });
  } catch (error) {
    console.log("error:", error);
  }
};
